import { SNoop } from '@obvious.tech/util/validation/schemas'
import { defineEntity } from '../../defineEntity'
import { ICertainty } from '@obvious.tech/constellation'

export const Certainty = defineEntity('Certainty', {
  endpoint: 'alarms/api/Certainty',
  schema: SNoop<ICertainty>(),
})
